import React from 'react'
import { colors, radius, shadow } from '../../styles/theme'

interface CardProps {
  children: React.ReactNode
  style?: React.CSSProperties
  padding?: string | number
  noBorder?: boolean
}

export function Card({ children, style, padding = '24px', noBorder = false }: CardProps) {
  return (
    <div style={{
      background: colors.surface,
      borderRadius: radius.lg,
      border: noBorder ? 'none' : `1px solid ${colors.border}`,
      boxShadow: shadow.xs,
      padding,
      ...style,
    }}>
      {children}
    </div>
  )
}

interface CardHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  style?: React.CSSProperties
}

export function CardHeader({ title, subtitle, actions, style }: CardHeaderProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 16,
      marginBottom: subtitle ? 4 : 0,
      ...style,
    }}>
      <div>
        <div style={{ fontSize: '17px', fontWeight: 600, color: colors.text, letterSpacing: '-0.01em', lineHeight: 1.3 }}>
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: '13px', color: colors.textSecondary, marginTop: 3 }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  )
}

interface SectionCardProps {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  style?: React.CSSProperties
  headerStyle?: React.CSSProperties
  bodyStyle?: React.CSSProperties
}

export function SectionCard({ title, subtitle, actions, children, style, headerStyle, bodyStyle }: SectionCardProps) {
  return (
    <Card style={style} padding={0}>
      {(title || subtitle || actions) && (
        <div style={{
          padding: '20px 24px',
          borderBottom: `1px solid ${colors.border}`,
          ...headerStyle,
        }}>
          <CardHeader title={title} subtitle={subtitle} actions={actions} />
        </div>
      )}
      <div style={{ padding: '20px 24px', ...bodyStyle }}>
        {children}
      </div>
    </Card>
  )
}
